import { IPsrVulnerability } from "@/models/psr/psr.types"

export class PsrVulnerability implements IPsrVulnerability {
  id: number
  label: string
  description: string
  requiresEndDate: boolean

  constructor(
    id: number,
    label: string,
    description: string,
    requiresEndDate: boolean,
  ) {
    this.id = id
    this.label = label
    this.description = description
    this.requiresEndDate = requiresEndDate
  }
}
